import VerifyEmailImage from '@app/assets/images/verify-email.webp';
import { BaseForm } from '@app/components/common/forms/BaseForm/BaseForm';
import { VerificationCodeInput } from '@app/components/common/VerificationCodeInput/VerificationCodeInput';
import * as Auth from '@app/components/layouts/AuthLayout/AuthLayout.styles';
import { ADMIN_BASE_BATH } from '@app/constants/variables';
import CountDownHandler from '@app/controllers/countDownController';
import { notificationController } from '@app/controllers/notificationController';
import { SendOtpHandler } from '@app/controllers/sendOtpController';
import { useAppDispatch } from '@app/hooks/reduxHooks';
import { deleteCounterToken } from '@app/services/localStorage.service';
import { doVerifySecurityCode } from '@app/store/slices/authSlice';
import { Image, Spin } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import * as S from './SecurityCodeForm.styles';

interface SecurityCodeFormProps {
  onBack?: () => void;
}

export const SecurityCodeForm: React.FC<SecurityCodeFormProps> = ({ onBack }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { state } = useLocation();

  const navigateBack = useCallback(() => navigate('/auth/login'), [navigate]);

  const [securityCode, setSecurityCode] = useState('');
  const OTPLength = Number(process.env.REACT_APP_OTP_CODE_LENGTH);

  const [timer, setTimer] = useState(true);

  const counterToggleFunctionality = () => {
    return setTimer(false);
  };

  const values = state;
  const [loginLoader, setLoginLoader] = useState(false);
  const setLoadingEnable = () => {
    return setLoginLoader(true);
  };
  const setLoadingDisable = () => {
    return setLoginLoader(false);
  };
  const handleSubmit = () => {
    SendOtpHandler(values, dispatch, navigate, t, setLoadingEnable, setLoadingDisable);
    setTimer(true);
  };

  useEffect(() => {
    if (securityCode.length === OTPLength) {
      dispatch(
        doVerifySecurityCode({
          otp: securityCode,
          email: state.email,
          rememberMe: state?.rememberMe || false,
        }),
      )
        .unwrap()
        .then(() => {
          deleteCounterToken('countDown');
          navigate(ADMIN_BASE_BATH);
        })
        .catch((err) => {
          notificationController.error({ message: err.message });
        });
    }
  }, [securityCode, dispatch, OTPLength, state.email, state.phone, state?.rememberMe, navigate]);

  return (
    <Auth.FormWrapper>
      <BaseForm layout="vertical">
        <Auth.BackWrapper onClick={onBack || navigateBack}>
          <Auth.BackIcon />
          {t('common.back')}
        </Auth.BackWrapper>
        <S.ContentWrapper>
          <S.ImageWrapper>
            <Image src={VerifyEmailImage} alt="Not found" preview={false} />
          </S.ImageWrapper>
          <Auth.FormTitle>{t('securityCodeForm.title')}</Auth.FormTitle>
          <S.VerifyEmailDescription>{t('common.verifyCodeSent')}</S.VerifyEmailDescription>
          {/* temp showing otp to user when request otp via phone once we start send SMS remove this */}
          <S.OtpText>{state.otp ? `OTP: ${state.otp}` : ''}</S.OtpText>
          {loginLoader ? <Spin /> : <VerificationCodeInput autoFocus onChange={setSecurityCode} length={OTPLength} />}
          {timer ? (
            <CountDownHandler counterToggleFunctionality={counterToggleFunctionality} />
          ) : (
            <>
              <S.LinkText onClick={handleSubmit}>{t('securityCodeForm.noCode')}</S.LinkText>
              <S.OrText>{t('securityCodeForm.or')}</S.OrText>
            </>
          )}

          {state.email && <S.LinkText onClick={onBack || navigateBack}>{t('securityCodeForm.changeEmail')}</S.LinkText>}
          {state.phone && <S.LinkText onClick={onBack || navigateBack}>{t('securityCodeForm.changePhone')}</S.LinkText>}
        </S.ContentWrapper>
      </BaseForm>
    </Auth.FormWrapper>
  );
};
